import { SelectProps as MUISelectProps } from "@mui/material/Select";
import { Wrapper, SelectBox } from "components/NativeSelect2.styled";

type NativeSelectProps = {
  value: any;
  onChange: (event?: any) => void;
  placeholder?: string;
  isRequire?: boolean;
  options: any[];
  optionValue?: string;
  optionLabel?: string;
  disabled?: boolean;
  SelectProps?: Partial<Omit<MUISelectProps, "value" | "onChange">>;
};

export const NativeSelect = ({
  value,
  onChange,
  placeholder,
  isRequire,
  options = [],
  optionValue = "id",
  optionLabel = "name",
  disabled,
  SelectProps,
  ...props
}: NativeSelectProps) => {
  const handleChange = (e: any) => {
    const value = e.target.value;
    if (value === placeholder) onChange(null);
    else onChange(value);
  };

  return (
    <Wrapper variant="outlined" {...props}>
      <SelectBox
        value={value || placeholder}
        onChange={handleChange}
        shouldInvalidate={!value || value === placeholder}
        disabled={disabled}
        native
        optioncolor={placeholder}
        {...SelectProps}
      >
        {placeholder && (
          <option value={placeholder} disabled={isRequire}>
            {placeholder}
          </option>
        )}
        {options.map((v) => (
          <option key={v[optionValue]} value={v[optionValue]}>
            {v[optionLabel]}
          </option>
        ))}
      </SelectBox>
    </Wrapper>
  );
};

export default NativeSelect;
